import React from "react";
import moment from "moment";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";

const SpecificMonthPage = data => {
  const year = Number(data.data.year);
  const month = Number(data.data.month);
  let currentYear = new Date().getFullYear();
  let currentDate = new Date().getDate();
  let currentMonth = new Date().getMonth() + 1;
  let dates = [];
  const staticMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  for (let i = 1; i <= moment(`${year}-${month}`, "YYYY-M").daysInMonth(); i++) {
    dates.push(i);
  }
  return (
    <div className="container">
      <div className={styles["sitemap-wrapper"]}>
        <h1 className={styles["header"]}>
          <Link href={`/site-map`}>Site Map</Link>
        </h1>
        <h3 className={styles["breadcrumb"]}>
          <Link href={`/site-map/${year}`}>{year}</Link> / <Link>{staticMonths[month - 1]}</Link>
        </h3>
        <ol className={styles["o-list-month"]}>
          {dates.map((date, index) => {
            if (
              (year === currentYear && month === currentMonth && index + 1 <= currentDate) ||
              month < currentMonth ||
              year < currentYear
            ) {
              return (
                <li className={styles["list"]}>
                  <Link href={`/site-map/${year}/${month}/${date}`}>{date}</Link>
                </li>
              );
            }
          })}
        </ol>
      </div>
    </div>
  );
};

export { SpecificMonthPage };
